var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { DEFAULT_DIRECT_LINK_VERSION } from '@lucidlink/sdk';
import { useAuthProvider, usePlugFilespaceClient, } from '@lucidlink/workspacemanagement';
import { FilespaceDirectLinkKeyFactory } from '../../../query-key-factories';
export const useFsEntryDirectLink = ({ filespaceId, fsEntryKey, workspaceId, }) => {
    _react_refresh_temp_1();
    const baseUrl = window.location.origin;
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const query = useQuery({
        queryKey: FilespaceDirectLinkKeyFactory.exact(fsEntryKey?.id || '', filespaceId || ''),
        queryFn: async () => {
            if (!filespaceId || !fsEntryKey) {
                return null;
            }
            return plugFilespaceClient({
                action: async (fsClient) => {
                    const entryPath = await fsClient
                        .fileSystem()
                        .getPath(fsEntryKey);
                    return fsClient
                        .directLinks()
                        .generate(baseUrl, entryPath, DEFAULT_DIRECT_LINK_VERSION);
                },
                filespaceId,
                workspaceId,
            });
        },
        enabled: Boolean(currentUser?.emailVerified && filespaceId && fsEntryKey),
        networkMode: 'always',
    });
    return { query };
};
_react_refresh_temp_1(useFsEntryDirectLink, "jRMx3r7nIBDWbUBVlsDJFgWprew=", false, () => [useAuthProvider, usePlugFilespaceClient, useQuery]);
